import React, { useRef } from "react";
import Drawer from "@mui/material/Drawer";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { updateDisplayInvoiceDrawer } from "../../../reducer/bookingReducer";
import { ReactComponent as PrinterIcon } from "../../../assets/icons/printerIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/downloadIcon.svg";
import NewInvoiceStructure from "../../common/Template/NewInvoiceStructure";
import { CircularProgress } from "@mui/material";
import usePrint from "../../../hooks/usePrint";
import usePdf from "../../../hooks/usePdf";

const ViewInvoiceDrawer = () => {
  const { displayInvoiceDrawer } = useSelector((store) => store.booking);
  const { hotelDetails } = useSelector((store) => store.login);

  const dispatch = useDispatch();
  const componentRef = useRef(null);
  const { editBookingAllowed } = useSelector((store) => store.usersRestriction);

  const { response: posData } = useSelector((store) => store.posSetting);
  const roomDetails = displayInvoiceDrawer?.roomDetails
    ? displayInvoiceDrawer?.roomDetails
    : {};

  const handleClose = () => {
    dispatch(updateDisplayInvoiceDrawer({}));
  };

  let roomInvoice = Array.isArray(displayInvoiceDrawer?.updatedInvoiceDetails)
    ? displayInvoiceDrawer?.updatedInvoiceDetails?.find(
        (Obj) => Obj?.invoiceType === "roomBill"
      )
    : {};

  const mySet = new Set();
  mySet.add(displayInvoiceDrawer?.invoiceId);

  let currentInvoice = displayInvoiceDrawer?.updatedInvoiceDetails?.find(
    (Obj) => Obj?.id === displayInvoiceDrawer?.invoiceId
  );

  const { loading: isInvoiceLoading, printFile: printInvoiceFile } = usePrint(
    componentRef,
    "Invoice"
  );
  const {
    loading: isDownloadInvoiceLoading,
    targetRef,
    generatePDF: generateInvoicePDF,
  } = usePdf("Invoice");

  return (
    <Drawer
      closeIcon={null}
      onClose={handleClose}
      open={displayInvoiceDrawer?.display}
      title={null}
      PaperProps={{
        sx: {
          width: "800px",
          height: "100vh",
          top: "auto",
          bottom: 0,
          overflow: "hidden",
        },
      }}
      sx={{
        "& .MuiDrawer-root": {
          position: "fixed",
          left: 0,
          right: 0,
          width: "30%",
        },
        "& .MuiPaper-root": {
          position: "absolute",
          marginLeft: "auto",
        },
      }}
      anchor={"right"}
      bodyStyle={{ height:"100vh" }}
      width={"60%"}
    >
      <div className="flex flex-col border-b-[1px] border-black p-3">
        <div className="flex justify-between items-center">
          <div></div>

          <div className="flex gap-3 items-center ">
            {editBookingAllowed && (
              <>
                {isInvoiceLoading ? (
                  <CircularProgress size={16} />
                ) : (
                  <PrinterIcon
                    onClick={printInvoiceFile}
                    className="cursor-pointer"
                  />
                )}

                {isDownloadInvoiceLoading ? (
                  <CircularProgress size={16} />
                ) : (
                  <DownloadIcon
                    onClick={generateInvoicePDF}
                    className="cursor-pointer"
                  />
                )}
              </>
            )}

            <CloseOutlined
              onClick={handleClose}
              className=" customCloseIconContainer"
            />
          </div>
        </div>
      </div>

      {displayInvoiceDrawer?.display ? (
<div className="w-full h-full bg-gray-100 py-4 flex justify-center items-start overflow-auto">
  <div
    className="scale-wrapper min-w-fit"
  >
    <div className="a4-paper">
        <NewInvoiceStructure
          targetRef={targetRef}
          hotelDetails={hotelDetails}
          bookingDetails={displayInvoiceDrawer?.bookingDetails}
          invoiceDetails={displayInvoiceDrawer?.updatedInvoiceDetails?.filter(
            (Obj) => Obj?.id === displayInvoiceDrawer?.invoiceId
          )}
          invoiceId={currentInvoice?.invoiceId}
          invoiceNum={currentInvoice?.invoiceNum}
          paymentDetails={displayInvoiceDrawer?.paymentDetails}
          checkedInvoiceId={mySet}
          customerDetails={displayInvoiceDrawer?.customerDetails?.[0]}
          response={displayInvoiceDrawer?.response}
          roomInvoice={roomInvoice}
          roomDetails={roomDetails}
          allSelected={false}
          isSingleInvoice={true}
          print={false}
          download={false}
          isComponent={true}
          posData={posData}
        />
        </div>
        
        </div>
        </div>
      ) : (
        <></>
      )}

      {isInvoiceLoading && (
        <NewInvoiceStructure
          hotelDetails={hotelDetails}
          bookingDetails={displayInvoiceDrawer?.bookingDetails}
          invoiceDetails={displayInvoiceDrawer?.updatedInvoiceDetails?.filter(
            (Obj) => Obj?.id === displayInvoiceDrawer?.invoiceId
          )}
          invoiceId={currentInvoice?.invoiceId}
          invoiceNum={currentInvoice?.invoiceNum}
          paymentDetails={displayInvoiceDrawer?.paymentDetails}
          checkedInvoiceId={mySet}
          customerDetails={displayInvoiceDrawer?.customerDetails?.[0]}
          response={displayInvoiceDrawer?.response}
          roomDetails={roomDetails}
          val={componentRef}
          roomInvoice={roomInvoice}
          isSingleInvoice={true}
          allSelected={false}
          print={true}
          download={false}
          posData={posData}
        />
      )}

      {isDownloadInvoiceLoading && (
        <NewInvoiceStructure
          targetRef={targetRef}
          hotelDetails={hotelDetails}
          bookingDetails={displayInvoiceDrawer?.bookingDetails}
          invoiceDetails={displayInvoiceDrawer?.updatedInvoiceDetails?.filter(
            (Obj) => Obj?.id === displayInvoiceDrawer?.invoiceId
          )}
          paymentDetails={displayInvoiceDrawer?.paymentDetails}
          checkedInvoiceId={mySet}
          invoiceId={currentInvoice?.invoiceId}
          invoiceNum={currentInvoice?.invoiceNum}
          customerDetails={displayInvoiceDrawer?.customerDetails?.[0]}
          response={displayInvoiceDrawer?.response}
          roomDetails={roomDetails}
          val={componentRef}
          roomInvoice={roomInvoice}
          allSelected={false}
          isSingleInvoice={true}
          print={false}
          download={true}
          isSingleDownload={true}
          posData={posData}
        />
      )}
    </Drawer>
  );
};

export default ViewInvoiceDrawer;
